import React from 'react';
import { AppBar } from './AppBar';
// import { BottomNav } from './BottomNav'; // Removed - bottom navigation not needed
import { cn } from '@/lib/utils';

interface MobileScaffoldProps {
  title?: string;
  showBack?: boolean;
  onBackClick?: () => void;
  rightAction?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * MobileScaffold - Main layout wrapper for mobile/Android UI
 * Features:
 * - Renders AppBar at top
 * - Simple layout wrapper without complex state management
 * - Bottom navigation removed as it was not needed
 */
export function MobileScaffold({
  title = 'ReActor',
  showBack = false,
  onBackClick,
  rightAction,
  children,
  className,
}: MobileScaffoldProps) {
  return (
    <div
      className={cn(
        'flex flex-col w-full overflow-hidden bg-white',
        // Use safe area insets for mobile devices
        // env(safe-area-inset-bottom) provides padding for system navigation bar
        'h-screen',
        '[height:100dvh]', // Dynamic viewport height (better for mobile)
        'pb-[max(env(safe-area-inset-bottom),16px)]', // Bottom safe area padding with minimum 16px for gesture area
        className
      )}
      style={{
        // CSS variables for safe area insets (fallback for older browsers)
        // Minimum 16px padding ensures gesture navigation area is accessible
        // eslint-disable-next-line react/forbid-dom-props
        paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 16px)',
      }}
    >
      {/* AppBar */}
      <AppBar
        title={title}
        showBack={showBack}
        onBackClick={onBackClick}
        rightAction={rightAction}
      />

      {/* Content Area */}
      <div className="flex-1 overflow-y-auto bg-background">
        {children}
      </div>

      {/* Bottom navigation removed - was not needed */}
    </div>
  );
}

/**
 * Conditional wrapper that only applies MobileScaffold on mobile
 * Use this when you want the same component to work on both web and mobile
 */
export function WithMobileScaffold({
  title,
  children,
  ...props
}: MobileScaffoldProps) {
  return (
    <MobileScaffold title={title} {...props}>
      {children}
    </MobileScaffold>
  );
}

export default MobileScaffold;
